export class GlobalEMailTemplate {
    internalId: string;
    title: string;
    subject: string;
    body: string;
    isRequired = false;
    id = 0;
}
